import { supabase } from '../supabase';
import { Importer } from '../utils/types';

export const getAllImporters = async (): Promise<Importer[]> => {
  try {
    const { data, error } = await supabase
      .from('importers')
      .select('*')
      .order('name', { ascending: true });

    if (error) {
      throw new Error(error.message);
    }

    return data as Importer[];
  } catch (error) {
    console.error('Error fetching importers:', error);
    throw error;
  }
};

export const createImporter = async (
  importer: Omit<Importer, 'id' | 'created_at'>
): Promise<Importer> => {
  try {
    const { data, error } = await supabase
      .from('importers')
      .insert(importer)
      .select()
      .single();

    if (error) {
      throw new Error(error.message);
    }

    return data as Importer;
  } catch (error) {
    console.error('Error creating importer:', error);
    throw error;
  }
};

export const updateImporter = async (
  id: number,
  importer: Partial<Importer>
): Promise<Importer> => {
  try {
    const { data, error } = await supabase
      .from('importers')
      .update(importer)
      .eq('id', id)
      .select()
      .single();

    if (error) {
      throw new Error(error.message);
    }

    return data as Importer;
  } catch (error) {
    console.error('Error updating importer:', error);
    throw error;
  }
};

export const deleteImporter = async (id: number): Promise<void> => {
  try {
    const { error } = await supabase.from('importers').delete().eq('id', id);

    if (error) {
      throw new Error(error.message);
    }
  } catch (error) {
    console.error('Error deleting importer:', error);
    throw error;
  }
};

export const getImporterById = async (id: number): Promise<Importer> => {
  try {
    const { data, error } = await supabase
      .from('importers')
      .select('*')
      .eq('id', id)
      .single();

    if (error) {
      throw new Error(error.message);
    }

    return data as Importer;
  } catch (error) {
    console.error('Error fetching importer:', error);
    throw error;
  }
};
